import * as styles from '../CommunityAuditAccuracyChart.css';

/**
 * Chart header component displaying only the title
 * (percentage removed since it's shown in Production Status panel)
 */
export function ChartHeader() {
  return (
    <div className={styles.graphHeader}>
      <span className={styles.graphTitle}>Audit Performance Over Time</span>
    </div>
  );
}
